import React, { Fragment } from 'react';

import { Grid } from '@material-ui/core';

import { bool, any, string, func, node, oneOfType, object } from 'prop-types';
import { withTheme } from 'styled-components';

import {
  Container,
  DialogContentStyled,
  DialogTitleStyled,
  DialogActionsStyled,
  ErroIcon,
  Button,
  Content,
} from './styles';

const Modal = ({
  open,
  onClose,
  title,
  content,
  children,
  color,
  onConfirm,
  cancelLabel,
  confirmLabel,
  okLabel,
  showIcon,
  maxWidth,
  actions,
  component,
  buttonWidth,
  theme,
  ...others
}) => (
  <Container {...others} open={open} onClose={onClose} maxWidth={maxWidth} role="alert">
    {title && <DialogTitleStyled>{title}</DialogTitleStyled>}

    <DialogContentStyled>
      <Grid container>
        {showIcon && !component && <ErroIcon iconcolor={color} />}

        {!component && <Content>{content || children}</Content>}

        {component || <Fragment />}
      </Grid>
    </DialogContentStyled>

    {actions && (
      <DialogActionsStyled>
        {onConfirm && (
          <Fragment>
            <Button onClick={onConfirm} background={theme.colors.secondary}>
              {confirmLabel}
            </Button>
            {cancelLabel === '' ? (
              <Fragment />
            ) : (
              <Button onClick={onClose} background="#ffffff" border="1.5px solid #bfbfbf" textcolor="#555555">
                {cancelLabel}
              </Button>
            )}
          </Fragment>
        )}

        {!onConfirm && (
          <Button
            onClick={onClose}
            width={buttonWidth}
            background="#ffffff"
            border="1.5px solid #bfbfbf"
            textcolor="#555555"
          >
            {okLabel}
          </Button>
        )}
      </DialogActionsStyled>
    )}
  </Container>
);

Modal.propTypes = {
  open: bool,
  onClose: func,
  title: any,
  content: any,
  color: string,
  onConfirm: oneOfType([func, bool]),
  cancelLabel: string,
  confirmLabel: string,
  okLabel: string,
  showIcon: bool,
  maxWidth: string,
  actions: bool,
  component: node,
  buttonWidth: string,
  theme: object,
};

Modal.defaultProps = {
  title: '',
  onConfirm: null,
  cancelLabel: 'Não, Alterar',
  confirmLabel: 'Sim, Confirmar',
  okLabel: 'Ok',
  showIcon: true,
  maxWidth: 'sm',
  actions: true,
  open: false,
  component: null,
};

export default withTheme(Modal);
